export default "<div (click)=\"fileAdd()\"></div>";